import {
  Box,
  Container,
  HStack,
  Link,
  Text,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';
import { Logo } from '../../Logo';

export const Footer = () => {
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const mutedText = useColorModeValue('gray.600', 'gray.400');

  return (
    <Box
      as="footer"
      borderTop="1px"
      borderColor={borderColor}
      py={8}
    >
      <Container maxW="container.xl">
        <VStack spacing={4}>
          <HStack spacing={8} flexWrap="wrap" justify="center">
            <Logo h="32px" />
            <Link
              href="#services"
              color={mutedText}
              _hover={{ color: 'brand.500' }}
            >
              Services
            </Link>
            <Link
              href="#case-studies"
              color={mutedText}
              _hover={{ color: 'brand.500' }}
            >
              Case Studies
            </Link>
            <Link
              href="mailto:hello@silentech.gr"
              color={mutedText}
              _hover={{ color: 'brand.500' }}
            >
              Contact
            </Link>
            <Link
              href="#company"
              color={mutedText}
              _hover={{ color: 'brand.500' }}
            >
              Εταιρικά στοιχεία
            </Link>
          </HStack>
          <Text fontSize="sm" color={mutedText}>
            &copy; {new Date().getFullYear()} SILENTECH ΜΟΝΟΠΡΟΣΩΠΗ Ι.Κ.Ε. · Γ.Ε.ΜΗ. 160351403000. All rights reserved.
          </Text>
        </VStack>
      </Container>
    </Box>
  );
};
